import { classNames } from "@NBCUDTC/reactjs-utility-belt/classnames";

import { Image } from "@/components/atoms/Image";
import { getImageUrl } from "@/utils/GetImageUrl";
import { ImageType } from "@/utils/shared-atom-types";

import styles from "./MiniGameTile.module.scss";
import { MiniGameTileProps } from "./types";

/**
 * MiniGameTile component renders a mini game tile to explore games on mobile.
 *
 * @param asset - The asset data to be displayed in the tile
 * @param className - Additional CSS class for styling
 *
 * @returns the rendered MiniGameTile component
 *
 * @example
 * ```tsx
 * <MiniGameTile asset={someAsset}/>
 * ```
 */
const MiniGameTile = ({ asset, className }: MiniGameTileProps) => {
  const cn = classNames(styles["mini-game-tile"], className);
  const imageUrl = getImageUrl(asset, ImageType.Scene34, {
    width: 255,
    height: 300,
  });

  return (
    <div className={cn}>
      <Image
        className={styles["mini-game-image"]}
        src={imageUrl}
        alt={asset.attributes.title}
      />
    </div>
  );
};

export { MiniGameTile };
